import { useEffect } from 'react'

function ResolutionError({ handleReturn }: any) {
  useEffect(() => {
    const minWidthResolutionPixels = 992

    const minResolutionInches = minWidthResolutionPixels / window.devicePixelRatio

    const calculateScreenWidthInches = () => {
      const screenWidthPixels = window.innerWidth
      const screenWidthInches = screenWidthPixels / window.devicePixelRatio
      if (
        screenWidthInches < minResolutionInches &&
        !(window.location.href.indexOf('auth') > -1) &&
        !(window.location.href.indexOf('competition') > -1) &&
        !(window.location.href.indexOf('campaigncard') > -1) &&
        !(window.location.href.indexOf('campaignflyer') > -1) &&
        !(window.location.href.indexOf('parker') > -1) &&
        !(window.location.href.indexOf('rd') > -1) &&
        !(window.location.href.indexOf('vilkaar') > -1)
      ) {
        handleReturn(true)
      } else {
        handleReturn(false)
      }
    }

    // Calculate initial screen width
    calculateScreenWidthInches()

    // Calculate screen width on resize
    window.addEventListener('resize', calculateScreenWidthInches)

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', calculateScreenWidthInches)
    }
  }, [])

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{/* Your website content goes here */}</>
}

export default ResolutionError
